module.exports = __webpack_public_path__ + "static/images/logo.f328f7b.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.gif
// module id = 838U
// module chunks = 1